// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"7fcc1d76","223":"008f5f5e","488":"e1a33856","732":"a170f4be","977":"400c9d17"}[chunkId] + ".chunk.js";
};